import api from './index';
//
let exports = {};

// 获取分管商户列表
exports.getMerchantDtoPageList = function (data, callback) {
    api.post('/merchtAll/merchant/dto/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

/* 获取打当前用户所属公司的可用审核人列表 */
exports.getComAuditorListByContext = function (data, callback) {// 获取上下文的公司审核人列表
    api.post('/merchtAll/com/auditor/list/get/by/context')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//
/* 根据comId获取上级公司（路径）列表 */
exports.getParentComListByContext = function (params, callback) {
    api.get('/merchtAll/parent/com/list/get/by/context')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

/* 根据comId、资源id、操作获取岗位列表 */
exports.getComRoleListByContext = function (data, callback) {
    api.post('/merchtAll/com/role/list/get/by/context')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getMerchtCsList = function (params, callback) {// 根据merchantId获得客服信息
    api.get('/merchtAll/cs/list')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

//
exports.sendSiteMsg = function (data, callback) {// 发送消息
    api.post('/merchtAll/site/msg/send/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.sendSiteMsgMail = function (data, callback) { // 用于 站内信 通用组件
    api.post('/merchtAll/msg/send/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.fetchSiteMsgList = function (data, callback) { // merchtAll
    api.post('/merchtAll/site/msg/list/fetch')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

/* 获取模版岗位-分页列表 */
exports.getTplComRoleList = function (data, callback) {
    api.post('/merchtAll/tpl/com/role/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
/* 根据模版岗位id获取模版岗位资源ids */
exports.getTplComRoleRescIdsByRoleId = function (data, callback) {
    api.get('/merchtAll/tpl/com/role/resc/ids/get/by/roleId')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
/* 查询模版岗位资源 */
exports.getTplComRoleRescByRoleIdAndRescId = function (data, callback) {
    api.post('/merchtAll/tpl/com/role/resc/get/by/roleId/and/rescId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
/* 手机App（固定）角色】关联资源-获取角色已关联的资源操作(回显)*/
exports.getTplComRoleRescListForMobApp = function (data, callback) {
    api.post('/merchtAll/tpl/com/role/resc/list/for/mobApp')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//================= 商户模版岗位-数据维护- =================
// 获取商户模版岗位-分页列表
exports.getMerchtTplRoleList = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取已关联职责业务范围的列表
exports.getMerchtTplRoleListForRef = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/list/for/ref/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 获取商户模版岗位
exports.getMerchtTplRoleById = function (data, callback) {
    api.get('/merchtAll/mercht/tpl/role/get')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存商户模版岗位
exports.saveMerchtTplRole = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 复制商户模版岗位
exports.doMerchtTplRoleCopy = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/copy/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 修改商户模版岗位
exports.updateMerchtTplRole = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除商户模版岗位
exports.deleteMerchtTplRole = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 商户模版岗位-上下移
exports.doMerchtTplRoleMove = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/move/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 商户模版岗位-关联移动端角色
exports.updateMerchtTplRoleMobAppRole = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/mob/app/role/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 商户模版岗位-清除移动端角色
exports.clearMerchtTplRoleMobAppRole = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/mob/app/role/clear/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 根据商户模版岗位id获取商户模版岗位资源ids
exports.getMerchtTplRoleRescIdsByRoleId = function (data, callback) {
    api.get('/merchtAll/mercht/tpl/role/resc/ids/get/by/roleId')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存商户模版岗位资源关系
exports.saveMerchtTplRoleRescs = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/rescs/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询商户模版岗位资源
exports.getMerchtTplRoleRescByRoleIdAndRescId = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/resc/get/by/roleId/and/rescId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存商户模版岗位资源
exports.updateMerchtTplRoleResc = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/resc/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 【手机App（固定）角色】关联资源-获取角色已关联的资源操作(回显)
exports.getMerchtTplRoleRescListForMobApp = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/resc/list/for/mobApp')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 【手机App（固定）角色】关联资源-保存角色关联资源操作
exports.saveMobAppRoleRescAndAction = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/mob/role/resc/action/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 根据岗位获取员工列表
exports.getMerchantStaffListByRoleIdAndMerchantType = function (data, callback) {
    api.get('/merchtAll/mercht/staff/list/by/roleId')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 职责权限-关联岗位
exports.doMerchtTplRoleRelComRole = function (data, callback) {
    api.post('/merchtAll/mercht/tpl/role/rel/com/role/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// ================================= 商户模版岗位_商品分类 =================================
// 根据商户模版岗位id获取岗位_商品分类ids
exports.getMerchtTplRoleGoodsCatIds = function (params, callback) {
    api.post('/merchtAll/mercht/tpl/role/goods/cat/catIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取商户模版岗位_商品
exports.getMerchtTplRoleGoodsCat = function (params, callback) {
    api.post('/merchtAll/mercht/tpl/role/goods/cat/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 保存商户模版岗位_商品
exports.saveMerchtTplRoleGoodsCats = function (params, callback) {
    api.post('/merchtAll/mercht/tpl/role/goods/cats/save/do')
    .data(params)
    .done(callback)
    .go();
};
// ================================= 商户模版岗位_服务分类 =================================
// 根据商户模版岗位id获取岗位_服务分类ids
exports.getMerchtTplRoleServcCatIds = function (params, callback) {
    api.post('/merchtAll/mercht/tpl/role/servc/cat/catIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取商户模版岗位_服务列表
exports.getMerchtTplRoleServcCat = function (params, callback) {
    api.post('/merchtAll/mercht/tpl/role/servc/cat/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 保存商户模版岗位_服务
exports.saveMerchtTplRoleServcCats = function (params, callback) {
    api.post('/merchtAll/mercht/tpl/role/servc/cats/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 获取商户报表快照-分页列表
exports.getMerchtReportSnapshotList = function (params, callback) {
    api.post('/merchtAll/mercht/report/snapshot/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 查询商户报表快照
exports.getMerchtReportSnapshotById = function (params, callback) {
    api.get('/merchtAll/mercht/report/snapshot/get')
    .params(params)
    .done(callback)
    .go();
};
// 商户业务权限范围-分页列表
exports.getMerchtBizPermScopeList = function (data, callback) {
    api.post('/merchtAll/mercht/biz/perm/scope/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询商户业务权限范围
exports.getMerchtBizPermScopeById = function (params, callback) {
    api.get('/merchtAll/mercht/biz/perm/scope/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 保存商户业务权限范围
exports.saveMerchtBizPermScope = function (data, callback) {
    api.post('/merchtAll/mercht/biz/perm/scope/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 修改商户业务权限范围
exports.updateMerchtBizPermScope = function (data, callback) {
    api.post('/merchtAll/mercht/biz/perm/scope/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 启禁用商户业务权限范围
exports.doMerchtBizPermScopeDisable = function (data, callback) {
    api.post('/merchtAll/mercht/biz/perm/scope/disable/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 删除商户业务权限范围
exports.deleteMerchtBizPermScope = function (data, callback) {
    api.post('/merchtAll/mercht/biz/perm/scope/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtAll.js
// module id = 29
// module chunks = 1